import { computed, makeAutoObservable } from "mobx";
import {
  LearningPathResponseApi,
  ObservableLearningPathPropImpl,
} from "../../DTO/ServerResponseType/LearningPath/LearningPath";

import { LearningPathsStore } from "./LearningPathsStore";
import { LearningPathStore } from "./LearningPathStore";
import { ModulesStore } from "./ModulesStore";

import { ModuleResponseApi } from "../../DTO/ServerResponseType/Module/Module";
import { ResourceIdAndNameResponseApi } from "../../DTO/ServerResponseType/Resource/Resource";
import { ResourcesStore } from "../ResourcesStore";

export class LearningPathWindowStore {
  showAddedLearningPathNode: boolean = false;
  showAddedLearningPathModuleCallout: boolean = false;
  showAddedLearningPathResourceCallout: boolean = false;
  showDeleteModalToDeleteLearningPath: boolean = false;
  deleteLearningPathData?: LearningPathResponseApi;
  showDeleteModalToDeleteLearningPathModule: boolean = false;
  showDeleteModalToDeleteLearningPathResource: boolean = false;
  deleteLearningPathModuleData?: {
    learningPath: LearningPathResponseApi;
    module: ModuleResponseApi;
  };
  deleteLearningPathResourceData?: {
    learningPath: ObservableLearningPathPropImpl;
    resource: ResourceIdAndNameResponseApi;
  };
  learningPathsStore: LearningPathsStore;
  modulesStore: ModulesStore;
  resourcesStore: ResourcesStore;
  addLearningPathStore: LearningPathStore;
  chosenLearningPathStore?: LearningPathStore;

  constructor() {
    this.learningPathsStore = new LearningPathsStore();
    this.modulesStore = new ModulesStore();
    this.resourcesStore = new ResourcesStore();
    this.addLearningPathStore = new LearningPathStore();
    makeAutoObservable(this);
  }

  addLearningPathAsync = async () => {
    this.learningPathsStore
      .addLearningPathAsync(this.addLearningPathStore.learningPath)
      .then(() => this.addLearningPathStore.learningPath.clear())
      .then(() => this.onAddedLearningPathNodeClose())
      .catch((err) => {
        console.log(err);
        alert("Возникла ошибка при добавлении");
      });
  };

  deleteLearningPathAsync = async (learningPathId: string) => {
    await this.learningPathsStore
      .deleteLearningPathAsync(learningPathId)
      .then(() => this.onDeleteModalToDeleteLearningPathClose())
      .catch(() => {
        alert("Возникла ошибка при удалении");
      });
  };

  deleteLearningPathModuleAsync = async () => {
    if (this.deleteLearningPathModuleData === undefined) {
      alert("Указанного модуля нет");
      return;
    }

    let learningPathModuleData: {
      learningPath: LearningPathResponseApi;
      module: ModuleResponseApi;
    } = this.deleteLearningPathModuleData;

    let learningPathStore = this.learningPathsStore.learningPathStores.find(
      (learningPathStore) =>
        learningPathStore.learningPath.learningPathId ===
        learningPathModuleData.learningPath.learningPathId
    );

    if (learningPathStore === undefined) {
      alert("Указанного пути обучения нет");
      return;
    }

    await learningPathStore
      .deleteLearningPathModuleAsync(learningPathModuleData.module.moduleId)
      .then(() => this.onDeleteModalToDeleteLearningPathClose())
      .catch(() => {
        alert("Возникла ошибка при удалении");
      });
  };

  async deleteLearningPathResourceAsync() {
    if (this.deleteLearningPathResourceData === undefined) {
      alert("Указанного ресурса нет");
      return;
    }

    let learningPathResourceData: {
      learningPath: LearningPathResponseApi;
      resource: ResourceIdAndNameResponseApi;
    } = this.deleteLearningPathResourceData;

    let learningPathStore = this.learningPathsStore.learningPathStores.find(
      (learningPathStore) =>
        learningPathStore.learningPath.learningPathId ===
        learningPathResourceData.learningPath.learningPathId
    );

    if (learningPathStore === undefined) {
      alert("Указанного пути обучения нет");
      return;
    }

    await learningPathStore
      .deleteLearningPathResourceAsync(
        learningPathResourceData.resource.resourceId
      )
      .then(() => this.onDeleteModalToDeleteLearningPathClose())
      .catch(() => {
        alert("Возникла ошибка при удалении");
      });
  }

  @computed get modulesWithoutLearningPathModules() {
    if (this.chosenLearningPathStore !== undefined)
      return this.modulesStore.searchedModules.filter(
        (module) =>
          this.chosenLearningPathStore?.learningPath.learningPathModules.find(
            (lpModule) => lpModule.module.moduleId === module.moduleId
          ) === undefined
      );
    else return this.modulesStore.searchedModules;
  }

  @computed get resourcesWithoutLearningPathResources() {
    if (this.chosenLearningPathStore !== undefined)
      return this.resourcesStore.filteredAndSortedAndSearchedResources.filter(
        (resource) =>
          this.chosenLearningPathStore?.learningPath.learningPathResources.find(
            (lpResource) =>
              lpResource.resource.resourceId === resource.resourceId
          ) === undefined
      );
    else return this.resourcesStore.filteredAndSortedAndSearchedResources;
  }

  onChangeChosenLearningPath(learningPathStore: LearningPathStore) {
    this.chosenLearningPathStore = learningPathStore;
  }

  onDeleteModalToDeleteLearningPathOpen = (
    learningPath: LearningPathResponseApi
  ) => {
    this.deleteLearningPathData = learningPath;
    this.showDeleteModalToDeleteLearningPath = true;
  };

  onDeleteModalToDeleteLearningPathClose = () => {
    this.deleteLearningPathData = undefined;
    this.showDeleteModalToDeleteLearningPath = false;
  };

  onDeleteModalToDeleteLearningPathModuleOpen = (
    learningPath: LearningPathResponseApi,
    module: ModuleResponseApi
  ) => {
    this.deleteLearningPathModuleData = {
      learningPath: learningPath,
      module: module,
    };
    this.showDeleteModalToDeleteLearningPathModule = true;
  };

  onDeleteModalToDeleteLearningPathModuleClose = () => {
    this.deleteLearningPathModuleData = undefined;
    this.showDeleteModalToDeleteLearningPathModule = false;
  };

  onDeleteModalToDeleteLearningPathResourceClose = () => {
    this.deleteLearningPathResourceData = undefined;
    this.showDeleteModalToDeleteLearningPathResource = false;
  };

  onDeleteModalToDeleteLearningPathResourceOpen(
    learningPath: ObservableLearningPathPropImpl,
    resource: ResourceIdAndNameResponseApi
  ) {
    this.deleteLearningPathResourceData = {
      learningPath: learningPath,
      resource: resource,
    };
    this.showDeleteModalToDeleteLearningPathResource = true;
  }

  onAddedLearningPathNodeShow = () => {
    this.showAddedLearningPathNode = true;
  };

  onAddedLearningPathNodeClose = () => {
    this.showAddedLearningPathNode = false;
  };

  onAddedLearningPathModuleCalloutShow = () => {
    this.showAddedLearningPathModuleCallout = true;
  };

  onAddedLearningPathModuleCalloutClose = () => {
    this.showAddedLearningPathModuleCallout = false;
  };

  onAddedLearningPathResourceCalloutShow = () => {
    this.showAddedLearningPathResourceCallout = true;
  };

  onAddedLearningPathResourceCalloutClose = () => {
    this.showAddedLearningPathResourceCallout = false;
  };
}
